import React from 'react';
import { useSelector } from 'react-redux';
import steps from '../../survey/stepsV2';
import SmartProgressBar from '../smartProgressBar';
import s from './index.module.scss';
import getParameterFromURL from '../../utils/scripts/getParameterFromURL';

const cx = (...args) => args.filter(Boolean).join(' ');

const HEADER_VARIANTS = {
  noBorder: new Set(['start_page_age', 'start_page_age_v2', 'training_time', 'start_page_age_v3']),
};

function SmartHeader() {
  const currentStep = useSelector((state) => state.steps.currentStep);
  const currentStepIndex = useSelector((state) => state.steps.currentStepIndex);
  const vetOnboarding = useSelector((state) => state.steps.vetOnboarding);
  const hideHeaderStepIndexes = useSelector((state) => state.steps.hideHeaderStepIndexes);
  const hideProgressStepIndexes = useSelector((state) => state.steps.hideProgressStepIndexes);
  const hideProgress = currentStepIndex !== null && hideProgressStepIndexes?.includes(currentStepIndex);
  const questions = useSelector((state) => state.questions.list);

  if (
    currentStepIndex !== null
    && hideHeaderStepIndexes?.includes(currentStepIndex)
  ) {
    return null;
  }

  const urlConfig = getParameterFromURL('config');
  const everydoggyV5 = getParameterFromURL('everydoggyV5') === 'true';
  const tariff = getParameterFromURL('tariff') || null;

  const BASE_STEPS_WITHOUT_BACK = new Set([
    'customV2_creating_program', 'customV2_email', 'customV2_plan', 'customV3_gender',
    'customV2_age_v3', 'customV4_behavior_problem', 'customV5_behavior_problem',
    'customV2_age_v2', 'receive_email', 'gender_zw', 'customV2_age_v4', 'customV2_age_v5', 'start_page_age', 'customV2_specialOffer_v2', 'start_page_age_v2', 'training_time', 'customV2_specialOffer_v3', 'start_page_age_v3',
  ]);

  const isGenderNoBackForCustomV13 = urlConfig === 'customV13' && currentStep === 'customV2_gender';
  const isGenderNoBackForCustomV2V5 = urlConfig === 'customV2' && everydoggyV5 && !tariff && currentStep === 'customV2_gender';

  const removeBackButton = BASE_STEPS_WITHOUT_BACK.has(currentStep)
    || isGenderNoBackForCustomV13
    || isGenderNoBackForCustomV2V5;

  const headerClassName = cx(
    s.header,
    HEADER_VARIANTS.noBorder.has(currentStep) && s.header_noBorder,
  );

  function goBack() {
    try {
      const isTrainingTime = currentStep === 'customV2_training_time';

      if (isTrainingTime) {
        const reasonAnswers = Object.values(questions?.customV2_reason?.answers || {});
        const dateAnswers = Object.values(questions?.customV2_date?.answers || {});
        const reasonIndex = reasonAnswers[0]?.index;

        if (reasonAnswers.length === 0 || reasonIndex === 'v8') {
          steps.navigate.back({ numberOfSteps: 3 });
        } else if (dateAnswers.length === 0) {
          steps.navigate.back({ numberOfSteps: 2 });
        } else {
          steps.navigate.back();
        }
      } else {
        steps.navigate.back();
      }

      steps.userMovedToPreviousStepByClick();
    } catch (error) {
      console.error('Error goBack:', error);
    }
  }

  return (
    <div className={s.headerWrapper}>
      <div className={headerClassName}>
        {!removeBackButton && (
          <button
            type="button"
            className={s.backButton}
            onClick={goBack}
            aria-label="Назад"
          />
        )}
        <div className={cx(s.logo, vetOnboarding && s.logoVet)} />
      </div>
      {!hideProgress && <SmartProgressBar />}
    </div>
  );
}

export default SmartHeader;
